import * as React from "react";
const SvgFiRrSickle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-Sickle_svg__a)">
      <path
        fill="#062147"
        d="M19.82 2.97A10.4 10.4 0 0 0 12.2.005C6.682.159 2.11 4.774 2.001 10.292a10.48 10.48 0 0 0 3.468 7.982l-4.018 4.018a.999.999 0 1 0 1.414 1.414l5.303-5.303c.588-.587.756-1.477.418-2.213a6.5 6.5 0 0 1-.5-3.761c.467-2.91 2.95-5.186 5.9-5.411 3.27-.247 6.225 1.978 6.876 5.18.095.466.53.8 1.005.8a1 1 0 0 0 .987-.84c.097-.6.144-1.143.144-1.66 0-2.86-1.13-5.533-3.18-7.528m-5.984 2.055c-3.862.294-7.11 3.275-7.724 7.087a8.5 8.5 0 0 0 .471 4.474 8.49 8.49 0 0 1-2.58-6.255c.085-4.467 3.788-8.203 8.252-8.328a8.44 8.44 0 0 1 6.17 2.402 8.5 8.5 0 0 1 2.003 3.015 8.53 8.53 0 0 0-6.593-2.395z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-Sickle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSickle;
